<template>
  <div>
    服务项目
  </div>
</template>

<script>
export default {
  name: 'Service',
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
